import { Icon } from "./Icon.tsx";

/** A diagonal ruler with tick marks — the distance-measurement tool. */
export function MeasureIcon() {
  return (
    <Icon>
      <path d="M4 20 L20 4" />
      <path d="M7 17 L9 15" />
      <path d="M10.5 14.5 L12.5 12.5" />
      <path d="M13.5 11.5 L15.5 9.5" />
      <path d="M17 9 L19 7" />
    </Icon>
  );
}
